import { Component } from '@angular/core'
import { Http } from '@angular/http'
import { NavController, NavParams, Events } from 'ionic-angular'
import { Location } from '../../services/location'
import { Near } from '../../services/near'
import { DOMAIN } from '../../config'

@Component({
  selector: 'map',
  template: '<div class="home-map"></div>',
  providers: [Location, Near]
})
export class Map {
  private map
  private markers
  private position
  private config

  constructor(private http: Http, private events: Events, private near: Near, location: Location) {
    // Will contain all of the markers data
    this.markers = []

    this.position = null

    this.config = {
      style: new google.maps.StyledMapType([{
        'featureType': 'poi',
        'elementType': 'labels.text',
        'stylers': [{
          'visibility': 'off'
        }]
      }, {
        'featureType': 'road.highway',
        'elementType': 'geometry',
        'stylers': [{
          'visibility': 'simplified'
        }, {
            'hue': '#ffd500'
          }, {
            'lightness': 20
          }]
      }, {
        'featureType': 'road.arterial',
        'elementType': 'labels.icon',
        'stylers': [{
          'visibility': 'simplified'
        }, {
            'lightness': 20
          }]
      }, {
        'featureType': 'road.highway',
        'elementType': 'labels.icon',
        'stylers': [{
          'visibility': 'simplified'
        }, {
            'lightness': 20
          }]
      }, {
        'featureType': 'landscape.natural',
        'stylers': [{
          'visibility': 'on'
        }, {
            'lightness': 30
          }]
      }], {
        name: 'Plan'
      }),
      options: {
        zoom: 15,
        center: new google.maps.LatLng(location.lat, location.lng),
        disableDefaultUI: true,
        minZoom: 12
      }
    }

    events.subscribe('carpostal:map:move', data => {
      let place = data.shift()

      // Build google coords from place retrieved
      let type = place.embedded_type
      let coords = place[type].coord
      let location = new google.maps.LatLng(coords.lat, coords.lon)

      this.map.panTo(location)
    })

    events.subscribe('carpostal:map:location', data => {
      let location = data.shift()

      this.map.panTo(location)
    })
  }

  ngAfterViewInit() {
    // Let's briefly delay map instantiation
    this.map = new google.maps.Map(document.querySelector('.home-map'), this.config.options)
    // Associate the styled map with the MapTypeId and set it to display.
    this.map.mapTypes.set('Plan', this.config.style)
    this.map.setMapTypeId('Plan')

    // Google maps Events
    google.maps.event.addListener(this.map, 'bounds_changed', () => {
      if (this.map.getZoom() < 15) {
        (<HTMLElement> document.querySelector('.home-map')).style.height = '100%'
      } else {
        this.events.publish('carpostal:map:idle') as any
        (<HTMLElement> document.querySelector('.home-map')).style.height = '70%'

        if (!this.position) {
          this.position = new google.maps.Marker({
            position: this.map.getCenter(),
            icon: {
              url: '/img/localisation.svg',
              size: new google.maps.Size(20, 20),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10),
              scaledSize: new google.maps.Size(20, 20)
            },
            map: this.map,
            zIndex: 5000
          })
        } else {
          this.position.setPosition(this.map.getCenter())
        }
      }
    })

    // Http
    this.http.get(`//${DOMAIN}/stops.json`)
      .map(res => res.json())
      .subscribe(
      data => {
        // For each stops we receive, just create a marker
        for (let stop of data) {
          let marker = new google.maps.Marker({
            position: new google.maps.LatLng(stop.lat, stop.lng),
            icon: {
              url: '/img/marker.png',
              size: new google.maps.Size(20, 20),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10),
              scaledSize: new google.maps.Size(20, 20)
            },
            title: stop.name,
            map: this.map
          }) as any

          marker.id = stop.id
          marker.pmr = stop.pmr
          marker.lines = stop.lines

          // Add this marker to our list array
          this.markers.push(marker)
        }

        // Once we finished, just get the nearest lines
        //this.near.get(this)

        // Subscribe idle event
        this.events.subscribe('carpostal:map:idle', () => {
          this.near.get(this)
        })
      },
      err => console.error(err),
      () => console.info('stops.json loaded & parsed')
      )
  }
}
